import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { BaseDialog } from '../../base-dialog';

@Component({
  selector: 'mandae-block-package-confirmation-dialog',
  templateUrl: './block-package-confirmation-dialog.component.html',
  styleUrls: ['../dialog-shared.scss', './block-package-confirmation-dialog.component.scss']
})
export class BlockPackageConfirmationDialogComponent extends BaseDialog<BlockPackageConfirmationDialogComponent> {

  constructor(
    dialogRef: MatDialogRef<BlockPackageConfirmationDialogComponent>
  ) {
    super(dialogRef);
  }

}
